import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/common.css';
import request from './assets/js/request';
import common from './assets/js/common';


Vue.config.productionTip = false;
Vue.prototype.request = request;
Vue.prototype.common = common;
let myapp= new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');

export default myapp;
